import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import {createSelector} from 'reselect';
import {push} from 'react-router-redux';


import * as styles from '../../styles';
import Tree from '../tree';
import {removeItemSelection} from '../tree/actions';
import {showMessage, hideMessage} from '../../paginator/actions';
import {refresh as paginatorRefresh, setSort} from '../../paginator/actions';
import PaginatedContainer from '../../paginator/paginated_container';
import {request} from '../../containers/actions';
import { ServerDate } from '../../containers/ServerDate';


export default class Users extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
        user: PropTypes.object,
    }

    static propTypes = {
        readonly: PropTypes.bool,
        selectable: PropTypes.bool,
        actions: PropTypes.array,
        buttonActions: PropTypes.array,
    }

    static defaultProps = {
        readonly: false,
        selectable: true,
        actions: [],
        buttonActions: [],
        params: {},
    }

    listFieldsSelector = createSelector(
        [
            () => this.context.user,
        ],
        () => this.context.user
            ? [
                ...this.context.user.is('admin')
                    ? [
                        {field: 'id', label: window.gettext('ID')},
                        {field: 'username', label: window.gettext('Username')},
                        {field: item => item.grade ? item.grade.title : '-', label: window.gettext('Grade')},
                        {
                            field: item => item.cell_phone
                                ? <span
                                    style={{
                                        backgroundColor: item.cell_phone_verified
                                            ? styles.successBackColor
                                            : styles.warningBackColor,
                                        color: item.cell_phone_verified
                                            ? styles.successColor
                                            : styles.warningColor,
                                        borderColor: item.cell_phone_verified
                                            ? styles.successBorderColor
                                            : styles.warningBorderColor,
                                        padding: '.5em',
                                    }}>
                                    {item.cell_phone.persian()}
                                </span>
                                : null,
                            label: window.gettext('Cell Phone'),
                        },
                    ]
                    : []
                ,
                {field: item => `${item.firstname} ${item.lastname}`, label: window.gettext('Name')},
                {field:"gender" , label:window.gettext('Gender')},
                {field: item => item.city ? item.city.name : '-' , label: window.gettext('City')},
                {field: item => item.city ? item.city.region_display : '-', label: window.gettext('Region')},
                ...this.context.user.is('admin') ? [{field: 'national_id', label: window.gettext('National ID')}] : [],
            ]
            : [],
    )

    filtersSelector = createSelector.bind(this)(
        [
            () => this.props.store.getIn(['userTypesTreeFilter']),
            () => this.props.store.getIn(['cellPhoneTreeFilter']),
            () => this.props.store.getIn(['regionsTreeFilter']),
            () => this.props.store.getIn(['citiesTreeFilter']),
            () => this.props.store.getIn(['gradesTreeFilter']),
        ],
        () => [
            {
                field: 'user_type',
                label: window.gettext('User Type'),
                component: <div style={{fontSize: '.8rem'}}>
                    <Tree
                        store={this.props.store.get('userTypesTreeFilter')}
                        readonly
                        header
                        resource='user-type'
                        label={window.gettext('User Type')}
                        staticItems={_.mapValues(Array(8), (__, index) => ({id: index, label: window.pgettext('user-type', 'Type-' + index)}))}
                    />
                </div>,
                selected: this.props.store.getIn(['userTypesTreeFilter', 'selected']).toJS(),
                remove: id => this.context.store.dispatch(removeItemSelection(
                    id,
                    'user-type',
                    this.props.store.getIn(['userTypesTreeFilter', 'elementId']),
                )),
            },
            {
                field: 'cell_phone_verified',
                label: window.gettext('Cell Phone'),
                component: <div style={{fontSize: '.8rem'}}>
                    <Tree
                        store={this.props.store.get('cellPhoneTreeFilter')}
                        readonly
                        header
                        resource='cell-phone-verified'
                        label={window.gettext('Cell Phone')}
                        staticItems={_.mapValues(Array(3), (__, index) => ({id: index, label: window.pgettext('cell-phone', 'State-' + index)}))}
                    />
                </div>,
                selected: this.props.store.getIn(['cellPhoneTreeFilter', 'selected']).toJS(),
                remove: id => this.context.store.dispatch(removeItemSelection(
                    id,
                    'cell-phone-verified',
                    this.props.store.getIn(['cellPhoneTreeFilter', 'elementId']),
                )),
            },
            {
                field: 'region',
                label: window.gettext('Region'),
                component: <div style={{fontSize: '.8rem'}}>
                    <Tree
                        store={this.props.store.get('regionsTreeFilter')}
                        readonly
                        header
                        resource='region'
                        itemLabel='name'
                        label={window.gettext('Region')}
                    />
                </div>,
                selected: this.props.store.getIn(['regionsTreeFilter', 'selected']).toJS(),
                remove: id => this.context.store.dispatch(removeItemSelection(
                    id,
                    'region',
                    this.props.store.getIn(['regionsTreeFilter', 'elementId']),
                )),
            },
            {
                field: 'city',
                label: window.gettext('City'),
                component: <div style={{fontSize: '.8rem'}}>
                    <Tree
                        store={this.props.store.get('citiesTreeFilter')}
                        readonly
                        header
                        resource='city'
                        itemLabel={city => `${city.region_display} - ${city.name}`}
                        filter={{
                            region: this.props.store.getIn(['regionsTreeFilter', 'selected']).keySeq().join(',') || -1,
                        }}
                        label={window.gettext('City')}
                    />
                </div>,
                selected: this.props.store.getIn(['citiesTreeFilter', 'selected']).toJS(),
                remove: id => this.context.store.dispatch(removeItemSelection(
                    id,
                    'city',
                    this.props.store.getIn(['citiesTreeFilter', 'elementId']),
                )),
            },
            {
                field: 'grade',
                label: window.gettext('Grade'),
                component: <div style={{fontSize: '.8rem'}}>
                    <Tree
                        store={this.props.store.get('gradesTreeFilter')}
                        readonly
                        header
                        resource='grade'
                        label={window.gettext('Grade')}
                    />
                </div>,
                selected: this.props.store.getIn(['gradesTreeFilter', 'selected']).toJS(),
                remove: id => this.context.store.dispatch(removeItemSelection(
                    id,
                    'grade',
                    this.props.store.getIn(['gradesTreeFilter', 'elementId']),
                )),
            },
        ],
    )

    buttonActionsSelector = createSelector(
        [
            () => this.props.buttonActions,
            () => this.props.readonly,
            () => this.props.store.getIn(['paginator', 'selected']).size > 0,
            () => this.props.store.getIn(['permissionsTree']),
        ],
        () => this.props.readonly
            ? this.props.buttonActions
            : _.concat(this.props.buttonActions, [
                {
                    label: window.gettext('New User'),
                    action: () => this.context.store.dispatch(push(
                        this.context.store.getState().getIn(
                            ['routing', 'locationBeforeTransitions', 'pathname'],
                        ) + 'add/',
                    )),
                },
                ...this.props.store.getIn(['paginator', 'selected']).size > 0
                    ? [
                        {
                            component: <div style={{height: '2.7em', display: 'inline-block'}}>
                                <div style={{float: 'right'}}>
                                    <Tree
                                        store={this.props.store.get('permissionsTree')}
                                        style={{minWidth: '13em'}}
                                        readonly
                                        resource='permission'
                                        combobox
                                        itemLabel={item => item.model + ' - ' + item.name}
                                        label={window.gettext('Permissions')}
                                    />
                                </div>
                                <button
                                    style={{...styles.button, marginRight: '.5em'}}
                                    onClick={async () => {
                                        if (!window.confirm(window.gettext('Are you sure you want to grant selected permissions to selected users?')))
                                            return;
                                        await this.context.store.dispatch(request({
                                            path: '/user/grant_permissions/',
                                            body: {
                                                users: this.props.store.getIn(['paginator', 'selected']).keySeq().toArray(),
                                                permissions: this.props.store.getIn(['permissionsTree', 'selected']).keySeq().toArray(),
                                            },
                                            method: 'PATCH',
                                        }));
                                        const messageId = ServerDate().getTime();
                                        this.context.store.dispatch([
                                            showMessage({
                                                message: window.gettext('Permission granted'),
                                                id: messageId,
                                            }, this.props.store.getIn(['paginator', 'elementId'])),
                                            paginatorRefresh(this.props.store.getIn(['paginator', 'elementId'])),
                                        ]);
                                        setTimeout(() => this.context.store.dispatch(hideMessage({
                                            id: messageId,
                                        }, this.props.store.getIn(['paginator', 'elementId']))), 3000);
                                    }}>
                                    <i className='fa-lock'></i>
                            &nbsp;
                                    {window.gettext('Grant Permission')}
                                </button>
                                <button
                                    style={{...styles.button, marginRight: '.5em'}}
                                    onClick={async () => {
                                        if (!window.confirm(window.gettext('Are you sure you want to withhold selected permissions from selected users?')))
                                            return;
                                        await this.context.store.dispatch(request({
                                            path: '/user/withhold_permissions/',
                                            body: {
                                                users: this.props.store.getIn(['paginator', 'selected']).keySeq().toArray(),
                                                permissions: this.props.store.getIn(['permissionsTree', 'selected']).keySeq().toArray(),
                                            },
                                            method: 'PATCH',
                                        }));
                                        const messageId = ServerDate().getTime();
                                        this.context.store.dispatch([
                                            showMessage({
                                                message: window.gettext('Permission withheld'),
                                                id: messageId,
                                            }, this.props.store.getIn(['paginator', 'elementId'])),
                                            paginatorRefresh(this.props.store.getIn(['paginator', 'elementId'])),
                                        ]);
                                        setTimeout(() => this.context.store.dispatch(hideMessage({
                                            id: messageId,
                                        }, this.props.store.getIn(['paginator', 'elementId']))), 3000);
                                    }}>
                                    <i className='fa-unlock'></i>
                            &nbsp;
                                    {window.gettext('Withhold Permission')}
                                </button>
                            </div>,
                            action: () => this.context.store.dispatch(push(
                                this.context.store.getState().getIn(
                                    ['routing', 'locationBeforeTransitions', 'pathname'],
                                ) + this.props.store.getIn(['paginator', 'selected']).keySeq().join(',') + '/',
                            )),
                        },
                    ]
                    : [],
            ]),
    )

    constructor(props) {
        super(props);
        this.tooltip = this.tooltip.bind(this);
    }

    componentDidMount() {
        this.context.store.dispatch(setSort(
            this.context.user.hasPerm('admin')
                ? [
                    {name: 'id', label: window.gettext('ID'), reversed: true},
                    {name: 'national_id', label: window.gettext('national id')},
                    {name: 'firstname', label: window.gettext('firstname')},
                    {name: 'lastname', label: window.gettext('lastname')},
                    {name: 'city', label: window.gettext('City')},
                    {name: 'region', label: window.gettext('Region')},
                ]
                : [
                    {name: 'firstname', label: window.gettext('firstname')},
                    {name: 'lastname', label: window.gettext('lastname')},
                ],
            this.props.store.getIn(['paginator', 'elementId']),
        ));
    }

    componentDidUpdate(prevProps) {
        if (prevProps.params.id && !this.props.params.id) {
            this.context.store.dispatch(paginatorRefresh(this.props.store.getIn(['paginator', 'elementId'])));
        }
    }

    tooltip(item) {
        return _.map(item.permissions, permission => permission.model + ' - ' + permission.name).join('\n');
    }

    render() {
        return <PaginatedContainer
            store={this.props.store.get('paginator')}
            resource='user'
            readonly={this.props.readonly}
            title={window.gettext('Users')}
            listFields={this.listFieldsSelector(this.props.store)}
            tooltip={this.tooltip}
            selectable={this.props.selectable}
            filters={this.filtersSelector(this.props.store)}
            pageSize={this.props.pageSize}
            active={this.props.params.id}
            actions={this.props.actions}
            buttonActions={this.buttonActionsSelector(this.props.store)}
        />;
    }
}

window.pgettext('cell-phone', 'State-0');
window.pgettext('cell-phone', 'State-1');
window.pgettext('cell-phone', 'State-2');
